import { INlpButton, INlpButtonRow, NlpButtonType } from "../../~store/models/Answer";
import { DEFAULT_BUTTON_ROW_ID } from "./TopicPairItemConstants";

export const getButtonRows = (buttons: INlpButton[] | undefined, buttonRowIds: number[]): INlpButtonRow[] => {
    const rows: INlpButtonRow[] = [{id: DEFAULT_BUTTON_ROW_ID, buttons: []}];

    buttonRowIds.forEach(rowId => {
        if (rowId !== DEFAULT_BUTTON_ROW_ID) {
            rows.push({
                id: rowId,
                buttons: []
            });
        }
    });

    const rowsById = new Map<number, INlpButtonRow>(rows.map(row => [row.id, row]));

    (buttons || []).forEach(button => {
        const rowId = button.rowId ?? DEFAULT_BUTTON_ROW_ID;
        let row = rowsById.get(rowId);
        if (!row) {
            row = {id: rowId, buttons: []};
            rowsById.set(rowId, row);
            rows.push(row);
        }
        row.buttons.push(button);
    });

    return rows;
};

export const getButtonRowIds = (buttons: INlpButton[] | undefined, buttonRowIds: number[]): number[] => {
    const rowIds: number[] = [DEFAULT_BUTTON_ROW_ID];

    buttonRowIds.forEach(rowId => {
        if (rowId !== DEFAULT_BUTTON_ROW_ID) {
            rowIds.push(rowId);
        }
    });

    (buttons || []).forEach(button => {
        const buttonRowId = button.rowId === undefined || button.rowId === null ? DEFAULT_BUTTON_ROW_ID : button.rowId;
        if (rowIds.indexOf(buttonRowId) === -1) {
            rowIds.push(buttonRowId);
        }
    });

    return rowIds;
};

export const canMoveNlpButtonToRow = (rowId: number, offset: number, buttons: INlpButton[] | undefined, buttonRowIds: number[]): boolean => {
    const rowIds = getButtonRowIds(buttons, buttonRowIds);
    const currentRowIndex = rowIds.indexOf(rowId);
    const targetRowIndex = currentRowIndex + offset;

    return (currentRowIndex !== -1 && targetRowIndex >= 0 && targetRowIndex < rowIds.length);
};

export const getNlpButtonImage = (type: NlpButtonType): string => {
    switch (type) {
        case NlpButtonType.Link:
            return require("./../../../shared/images/url.png");
        case NlpButtonType.Trigger:
            return require("./../../../shared/images/trigger.png");
        case NlpButtonType.Text:
            return require("./../../../shared/images/text.png");
        case NlpButtonType.CustomEvent:
            return require("./../../../shared/images/js.png");
        case NlpButtonType.Back:
            return require("./../../../shared/images/arrow-go-back.png");
        case NlpButtonType.RequestContact:
            return require("./../../../shared/images/personal-info.png");
        case NlpButtonType.RequestGeolocation:
            return require("./../../../shared/images/personal-info.png");
    }
};

export const changeNlpButtonPosition = (buttons: INlpButton[], buttonName: string, rowId: number, isUpDirection: boolean): INlpButton[] => {
    const rowButtons = [...buttons].filter(button => (button.rowId ?? DEFAULT_BUTTON_ROW_ID) === rowId);
    const rowButtonIndex = rowButtons.findIndex(button => button.name === buttonName);
    if (rowButtonIndex < 0) {
        return buttons;
    }

    const targetIndex = isUpDirection ? rowButtonIndex - 1 : rowButtonIndex + 1;
    if (targetIndex < 0 || targetIndex >= rowButtons.length) {
        return buttons;
    }

    const currentButton = rowButtons[rowButtonIndex];
    rowButtons[rowButtonIndex] = rowButtons[targetIndex];
    rowButtons[targetIndex] = currentButton;

    let rowIndex = 0;
    return [...buttons].map(button => {
        if ((button.rowId ?? DEFAULT_BUTTON_ROW_ID) !== rowId) {
            return button;
        }
        return rowButtons[rowIndex++];
    });
};

export const moveNlpButtonToRow = (buttons: INlpButton[], item: INlpButton, sourceRowId: number, targetRowId: number): INlpButton[] | undefined => {
    const updatedButtons = [...buttons];
    const buttonIndex = updatedButtons.findIndex(button => button.name === item.name && button.value === item.value && (button.rowId ?? DEFAULT_BUTTON_ROW_ID) === sourceRowId);

    if (buttonIndex === -1) {
        return undefined;
    }

    const [buttonToMove] = updatedButtons.splice(buttonIndex, 1);
    const lastTargetRowButtonIndex = updatedButtons.reduce(
        (lastIndex, button, index) =>
            (button.rowId ?? DEFAULT_BUTTON_ROW_ID) === targetRowId ? index : lastIndex,
        -1
    );

    const insertionIndex = lastTargetRowButtonIndex === -1 ? updatedButtons.length : lastTargetRowButtonIndex + 1;
    const movedButton: INlpButton =
        targetRowId === DEFAULT_BUTTON_ROW_ID
            ? {type: buttonToMove.type, name: buttonToMove.name, value: buttonToMove.value}
            : { ...buttonToMove, rowId: targetRowId};

    updatedButtons.splice(insertionIndex, 0, movedButton);
    return updatedButtons;
};